/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from 'redux';
import reduxthunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import rootReducer from 'edrolo/rootReducer';
import sagas from 'edrolo/rootSagas';

const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware, reduxthunk];
const noop = (f) => f;

let reduxDevToolsHook = noop;

// load a logger in dev
if (process.env.NODE_ENV !== 'production') {
  // redux logger
  const logger = createLogger({
    collapsed: true,
    logErrors: true,
  });

  middleware.push(logger);

  if (global.__REDUX_DEVTOOLS_EXTENSION__) {
    reduxDevToolsHook = global.__REDUX_DEVTOOLS_EXTENSION__();
  }
}

const storeEnhancers = compose(
  applyMiddleware(...middleware),
  reduxDevToolsHook
);

export default function () {
  const initialState = rootReducer(undefined, { type: '' });

  const store = createStore(rootReducer, initialState, storeEnhancers);

  // epic sagas..
  sagaMiddleware.run(sagas);

  return store;
}
